import { FC, memo } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import s from './FooterBlurb.scss';

export interface Props {
  className?: string;
}

const FooterBlurb: FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  return <div className={c(s['root'], className)}>{t('siteFooter.blurb')}</div>;
};
FooterBlurb.displayName = 'FooterBlurb';

export default memo(FooterBlurb);
